<template>
  <section>
    <div class="container">
<!--      <vx-card>-->
<!--        <div class="con-select-example justify-between">-->
<!--          <h3>Code Snippet</h3>-->
<!--          <div class="con-select-example justify-between">-->
<!--            <vs-select-->
<!--              class="selectExample"-->
<!--              v-model="selectedOpt"-->
<!--              icon="arrow_downward"-->
<!--              v-on:input="updateCodeSnippet"-->
<!--              >-->
<!--              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in codeSnippetOpts" />-->
<!--            </vs-select>-->
<!--            <feather-icon icon="CopyIcon" svgClasses="h-8 w-8 stroke-current text-grey ml-4 cursor-pointer" v-clipboard:copy="message" v-clipboard:success="onCopySuccess"-->
<!--            v-clipboard:error="onCopyError" class="block" />-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="w-full mt-5">-->
<!--          <vx-card card-background="#F7F8F9" no-shadow>-->
<!--            <pre ref="snippet_1" id="snippet_1" v-show="setLangCode===1" >-->
<!--## package needed json,requests,pprint-->
<!--## _FILENAME_ = name of the resume file with extension (ex. johnresume.pdf)-->
<!--## _FILEPATH_ = path to the resume file (ex. /home/user/resumes/pdf/johnresume.pdf)-->

<!--import json-->
<!--import requests-->
<!--from pprint import pprint-->
<!--api_url = "http://parser.getboarded.tech/api/parser"-->
<!--files=[('file',('__FILENAME__',open('__FILEPATH__','rb'),'application/pdf'))]-->
<!--resume_body = {'personal_details':'True','work_experience':'True','educational_details':'True','skills':'True',-->
<!--               'languages':'True','projects':'True','certificates':'True','hobbies':'True'}-->
<!--url_api = "http://parser.getboarded.tech/api/parser"-->
<!--responses = requests.post(url=url_api,files=files, data=resume_body)-->
<!--pprint(responses.json(),sort_dicts=False)-->
<!--            </pre>-->
<!--            <pre ref="snippet_2" id="snippet_2" v-show="setLangCode===2" >-->
<!--              VueJS Not Available Right Now-->
<!--              Comming Soon-->
<!--            </pre>-->
<!--            <pre ref="snippet_3" id="snippet_3" v-show="setLangCode===3" >-->
<!--              ReactJS Not Available Right Now-->
<!--              Comming Soon-->
<!--            </pre>-->
<!--            <pre ref="snippet_4" id="snippet_4" v-show="setLangCode===4" >-->
<!--              AngularJS Not Available Right Now-->
<!--              Comming Soon-->
<!--            </pre>-->
<!--          </vx-card>-->
<!--        </div>-->
<!--      </vx-card>-->
    </div>
  </section>
</template>

<script>
import VxCard from '../../../components/vx-card/VxCard.vue'
  export default {
  components: { VxCard },
    name: "CodeSnippet",
    data() {
      return {
        setLangCode : 1,
        selectedOpt : 1,
        codeSnippetOpts :[
          {text: 'Python', value: 1},
          {text: 'VueJS', value: 2},
          {text: 'ReactJS', value: 3},
          {text: 'AngularJS', value: 4},
        ],
        message : ''
      }
    },
    mounted() {
      this.message = this.$refs["snippet_1"].innerHTML;
    },
    methods: {
      updateCodeSnippet: function(e){
        this.setLangCode = e;
        this.message = this.$refs['snippet_' + e].innerHTML;
      },
      onCopySuccess: function () {
        this.$vs.notify({
            title: 'Success',
            text: 'Text copied successfully',
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
        })
      },
      onCopyError: function () {
        this.$vs.notify({
            title: 'Failed',
            text: 'Error in copying text, Use Ctrl + C',
            color: 'danger',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-alert-circle'
        })
      }
    }
  }
</script>

<style scoped>
.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}
section {
  padding: 2rem 10rem 2rem 10rem;
  background: #FFFFFF;
  position: relative;
}
pre {
  padding: 2rem;
  background: #F7F8F9;
  border-radius: 12px;
  overflow: auto;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%
  }
}
@media (max-width: 1200px) {

  section {
    padding: 2rem 0rem 4rem 0rem;
  }
}
</style>
